import {PageTemplate} from "../../shared/layout/PageTemplate";
import {LossContent} from "./components/LossContent";

export function Loss() {
    return <PageTemplate pageName="Loss" title="Enum" content={<LossContent/>}/>

}